import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TemplateService } from '../template.service';
import { Medium } from 'src/app/media/medium.model';
import { DatePipe, JsonPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Template } from '../template.model';
import { MediaService } from 'src/app/media/media.service';
import { switchMap } from 'rxjs/operators';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'fnsr-template-details',
  standalone: true,
  imports: [JsonPipe, DatePipe, FormsModule, RouterModule],
  templateUrl: './template-details.component.html',
  styles: ``
})
export class TemplateDetailsComponent implements OnInit {
  template: Template | null = null;
  availableMedia: Medium[] = [];
  selectedAward: string = '';
  selectedInformation: string = '';

  constructor(
    private route: ActivatedRoute,
    private templateService: TemplateService,
    private mediaService: MediaService
  ) {}

  ngOnInit() {
    this.route.params.pipe(
      switchMap(param => {
        const templateId = param['id'];
        return forkJoin({
          template: this.templateService.getTemplate(templateId),
          media: this.mediaService.getMedia()
        });
      })
    ).subscribe(({ template, media }) => {
      this.template = template;
      this.availableMedia = media;
    });
  }

  getTemplate(id: string): void {
    this.templateService.getTemplate(id).subscribe(
      result => this.template = result,
      err => console.log(err)
    );
    console.log(this.template)
  }

  addAwardId(): void {
    if (this.template && this.selectedAward) {
      this.template.awardIds.push(this.selectedAward);
      this.selectedAward = '';
    }
  }

  removeAwardId(awardId: string): void {
    if (this.template) {
      this.template.awardIds = this.template.awardIds.filter(id => id !== awardId);
    }
  }

  addInformationId(): void {
    if (this.template && this.selectedInformation) {
      this.template.informationIds.push(this.selectedInformation);
      this.selectedInformation = '';
    }
  }

  removeInformationId(infoId: string): void {
    if (this.template) {
      this.template.informationIds = this.template.informationIds.filter(id => id !== infoId);
    }
  }
}